import React, { Fragment, useCallback, useMemo, useState } from 'react'

import Modal from '@Modal/V3/Modal'

import getFormStatus from '@/Form/Functions/getFormStatus'

import DCDashboardStore from '@/Stores/DCDashboard'

import Loader from '@Pure/Loader'

import ajaxRequest from '@function/ajax/ajaxRequest'

import { isTrue } from '@root/utility'

export default function DeleteDiscountcodesModal ({ onClose, onDeletion, ...props })
{
	const [deleted, setDeleted] = useState(false);
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState({ });

	const selected_codes = DCDashboardStore.useState(function (store)
	{
		return Object.keys(store).filter(id => isTrue(store[id]));
	});

	const resetModal = useCallback(function ()
	{
		setStatus({ });
		setLoading(false);
		setDeleted(false);
	},
	[]);

	const deleteCodes = useCallback(function (e)
	{
		setLoading(true);

		(async function ()
		{
			try
			{
				var response = await ajaxRequest('/discount-codes/delete',
				{
					data: { codes: selected_codes },
					min_duration: 1000
				});
			}
			catch (update)
			{
				setLoading(false);

				return setStatus(update);
			}

			setLoading(false);
			setStatus(response);
			setDeleted(true);

		// retire toute sélection
			DCDashboardStore.update(store => ({ }));

			onDeletion();

			window.setTimeout(onClose, 800);
		})();
	},
	[selected_codes, onClose, onDeletion]);

	const modal_delete = useMemo(function ()
	{
		if (deleted) return <Fragment />;

		return (
			<Fragment>
				<button type="button" className="c-btn c-btn--delete"
					onClick={ deleteCodes }>
					Supprimer ces codes
				</button>

				<button type="button" className="c-btn" onClick={ onClose }>
					Fermer
				</button>
			</Fragment>
		);
	},
	[onClose, deleteCodes, deleted]);

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
	)
	: undefined;

	return (
		<Modal open={ props.open === true } trg={ props.trg }
			title="Confirmation de suppression"
			onClose={ onClose }
			footer={ modal_delete }
			afterHidden={ resetModal }>
			{
				deleted ? getFormStatus(status) : getFormStatus(
				{
					warning: 'Supprimer ces codes ? Vous pourrez toujours les réimporter par la suite.'
				})
			}
			{ loader }
		</Modal>
	);
}